<template>

    <v-content>
        <v-container fluid>

            <panelcontainer>
                <div class="headline" slot="headline">Satınalma / {{this.proforma_type.toUpperCase()}}</div>
                <div slot="actions">
					<actions v-if="getAuth.isAdmin" module="proforma" :item="item" />
                    <v-btn tile color="indigo" dark @click="saveItem()">
                        <v-icon>{{mdiContentSave}}</v-icon> Kaydet
                    </v-btn>
                </div>
                <loading v-if="isLoading" text="Teklif bilgileri yükleniyor..." size="80" width="2" />

                <template v-if="!isLoading">
                    <v-container grid-list-md mt-3>
                        <v-layout wrap>
                            <v-flex md7 sm6 mb-3 >
                                <v-text-field label="Konu" v-model="item.title" outlined hide-details placeholder="Örn: Lanxess Germany"></v-text-field>
                            </v-flex>
                            <v-flex md3 sm6 mb-3>
                                <v-select v-model="item.user_id" :items="users" item-text="fullname" item-value="id" label="Teklif Sahibi" outlined hide-details></v-select>
                            </v-flex> 
                            <v-flex md2 sm4 mb-3>
                               <datepicker label="Düzenleme Tarihi"  v-model="item.date_edit_text" locale="tr-tr"/> 
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-container grid-list-md mt-3>
                        <v-layout wrap> 
                            <v-flex md2  sm4 xs6 mb-3 >
                                <v-text-field label="Gönderen" v-model="item.text_from" outlined hide-details ></v-text-field>
                            </v-flex> 
                            <v-flex md2 sm4 xs6 mb-3 >
                                <v-text-field label="Paket" v-model="item.text_packing" outlined hide-details ></v-text-field>
                            </v-flex> 
                            <v-flex md2 sm4 xs6 mb-3 >
                                <v-text-field label="Yükleme Zamanı" v-model="item.text_shipment" outlined hide-details ></v-text-field>
                            </v-flex> 
                            <v-flex md2 sm4 xs6 mb-3 >
                                <v-text-field label="Vade" v-model="item.text_term" outlined hide-details ></v-text-field>
                            </v-flex> 
                            <v-flex md2 sm4 xs6 mb-3 >
                                <v-text-field label="Özel" v-model="item.text_custom" outlined hide-details ></v-text-field>
                            </v-flex> 
                            <v-flex md2 sm4 xs6 mb-3 >
                                <v-text-field label="Geliş Zamanı" v-model="item.text_loading_time" outlined hide-details ></v-text-field>
                            </v-flex> 
                        </v-layout>
                    </v-container>
					<table class="table table-striped table-borderless table-hover">
                        <thead>
                            <tr>
                                <th style="width:1%;">No</th>
                                <th>ÜRÜN ADI</th>
                                <th style="width:120px">Package</th>  
                                <th style="width:120px;text-align:right">UnitKg</th>  
                                <th style="width:120px;text-align:right">TotalKg</th>  
                                <th style="width:120px;text-align:right" >UnitPrice</th>  
                                <th style="width:120px;text-align:right" >TotalPrice</th>  
                                <th style="width:1%;" class="actions"></th>
                                <th style="width:1%;" class="actions"></th>
                            </tr>
                        </thead>
                        <tbody class="no-border-x">
                            <tr v-for="(entry, entryIndex) in item.entries" :key="entryIndex"  class="entryItem">
								<td>{{entryIndex + 1}}</td>
                                <td class="cell-detail">
                                    <v-autocomplete v-model="entry.product_id" :items="products" item-value="id" item-text="fullname" :label="_empty_label" outlined hide-details="" dense
									v-on:input="updateEntryProduct(entryIndex)" ></v-autocomplete>
                                </td> 
                                <td> 
									<inputtffloat v-model="entry.package"/> 
								</td> 
                                <td align=right> 
									<span v-if="entry.product_id">{{productsWithId[entry.product_id].unit_kg}}</span>
								</td> 
                                <td align=right> 
									<span v-if="entry.product_id">{{(productsWithId[entry.product_id].unit_kg * entry.package).toFixed(2)}}</span>
								</td> 
                                <td align=right> 
									<span v-if="entry.product_id">{{productsWithId[entry.product_id].price}} {{entry.kur}}</span>
								</td> 
                                <td align=right> 
									<span v-if="entry.product_id">{{(productsWithId[entry.product_id].price * entry.package).toFixed(2)}} {{entry.kur}}</span>
								</td>  
                                <td class="actions">
                                    <v-btn small icon color="primary" dark @click="addEntry(entryIndex)">
                                        <v-icon>{{mdiTableRowPlusBefore}}</v-icon>
                                    </v-btn>
                                </td>
                                <td class="actions">
                                    <v-btn small icon color="red" dark @click="removeEntry(entryIndex)">
                                        <v-icon>{{mdiCloseCircle}}</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </table> 
					<div class="text-center mb-4">
						<v-btn tile color="green" dark @click="addEntry()">
							<v-icon>{{mdiPlus}}</v-icon> Yeni Satır Ekle
						</v-btn>
					</div> 


                </template>
            </panelcontainer>



            <v-snackbar v-model="actionDialogShow" :color="actionDialogColor" :timeout="3000" top>
                {{ actionDialogText }}
                <v-btn dark text @click="actionDialogShow = false">
                    Tamam
                </v-btn>
            </v-snackbar>

        </v-container>
    </v-content>


</template>


<script>
    import loading from "@/components/utils/loading"
    import panelcontainer from "@/components/utils/panelcontainer"
    import inputtffloat from "@/components/inputs/tffloat"
    import datepicker from "@/components/inputs/datepicker"
    import actions from "@/components/utils/actions"
    import {
        mdiPlus,
        mdiCloseCircle,
        mdiBellCheck,
        mdiTimerSand,
        mdiEmailSend,
        mdiCalendarRange,
        mdiTableRowPlusBefore,
        mdiContentSave,
    } from '@mdi/js';
    export default {
        components: {
            loading,
            panelcontainer,
            inputtffloat,
            datepicker,
            actions,
        },
        data: () => ({
            mdiPlus: mdiPlus,
            mdiCloseCircle: mdiCloseCircle,
            mdiBellCheck: mdiBellCheck,
            mdiTimerSand: mdiTimerSand,
            mdiEmailSend: mdiEmailSend,
            mdiCalendarRange: mdiCalendarRange,
            mdiTableRowPlusBefore: mdiTableRowPlusBefore,
            mdiContentSave: mdiContentSave,

            isLoading: false,
            dialogEditor: false,
			dialogRemove: false,

			proforma_type : "",
			
            users: [ ], 
            products: [ ], 
            productsWithId: {}, 
			item: {}, 

			kurs : ["EUR","USD","TRY"],
			
            actionDialogShow: false,
            actionDialogText: "",
            actionDialogColor: "",
        }),
		mounted(){
			this.proforma_type = this.$route.params.proforma_type;
			this.item_id = this.$route.query.id || ""
			this.loadUsers() 
			this.loadProducts()  
			this.loadItem() 
		},
        methods: {
			loadUsers(){
				this.$http.get( process.env.VUE_APP_API_URL + "/users/shared", {
					params : { }
				}).then(response => {
					this.users = response.body;  
				}) 
			},
			loadProducts(){
				this.$http.get( process.env.VUE_APP_API_URL + "/products/legit", {
					params : { }
				}).then(response => {
					this.products = response.body;  
					var list = {};
					for(var i in this.products){
						list[ this.products[i].id ] = this.products[i];
						list[ this.products[i].id ].price = this.proforma_type == "yi" ? this.products[i].price_sell : this.products[i].price_buy;
					}
					this.productsWithId = list;
				}) 
			}, 
			loadItem(){
				this.isLoading = true;
				if(this.item_id == ""){
					this.setNewItemData();
					this.isLoading = false; 
				}else{ 
					this.$http.get( process.env.VUE_APP_API_URL + "/proformas/info", {
						params : { id : this.item_id, proforma_type : this.proforma_type }
					}).then(response => {
						this.item = response.body; 
						this.isLoading = false; 
					})  
				}
			},
			setNewItemData(){
				this.item = {
					id:"",
					title : "",
					user_id : 0,
					date_edit_text : "",
					date_end_text : "", 
					entries : [], 
					description : "",
					conditions : "",
				} 
				this.addEntry()
				this.addEntry()
			},
			addEntry(before){
				var entry = {
					product_id : 0,
					package : 0.0, 
					kur : "EUR", 
				}
				if(before === 0 || before > 0){
					this.item.entries.splice(before, 0, entry);
				}
				else{
					this.item.entries.push(entry)
				}
			},
			removeEntry(i){
				this.item.entries.splice(i, 1);
			},  
			updateEntryProduct(entryIndex){
				if(this.item.entries[entryIndex].product_id){
					for(var i in this.products){
						if(this.products[i].id == this.item.entries[entryIndex].product_id){ 
							this.item.entries[entryIndex].price = this.products[i].price_sell
							this.item.entries[entryIndex].kur = this.products[i].kur
						}
					}
				}
			},
            saveItem() {
				this.isLoading = true; 
				this.item.proforma_type = this.proforma_type
				this.$http.post( process.env.VUE_APP_API_URL + "/proformas/save", this.item).then(response => {  
					if(response.body.success){
						this.actionDialogShow = true;
						this.actionDialogText = "Kayıt başarılı"
						this.actionDialogColor = "green"
						this.$router.replace("/proformas/"+this.proforma_type+"/edit/?id="+response.body.id)
						setTimeout(()=>{
							location.reload();
						},500)
					}
					else{
						this.actionDialogShow = true;
						this.actionDialogText = response.body.reason
						this.actionDialogColor = "red" 
						this.isLoading = false;
					} 
				}) 
            }, 
        },
		computed:{
			getAuth(){
				return this.$store.getters.getAuth;
			} 
		}
    }
</script>

<style>

</style>